import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { CaseStructure } from './components/CaseStructure';
import { Volumes } from './components/Volumes';
import { Tools } from './components/Tools';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Creator } from './components/Creator';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="28sl3gxardmez">
      <MetaPixel data-id="element-1" data-mp="23utcq6luo6cd" />
      <Hero data-id="element-2" data-mp="23t8hsfvmildz" />
      <main data-id="element-3" data-mp="23ti6m04xmmi3">
        <BeforeAfter data-id="element-4" data-mp="3ik7gihlkcdr6" />
        <CaseStructure data-id="element-5" data-mp="3ikqy1x7ax04o" />
        <Volumes data-id="element-6" data-mp="3ijfx0558q6h9" />
        <Tools data-id="element-7" data-mp="3ihv22ef0kliv" />
        <Bonuses data-id="element-8" data-mp="3ii4ppvcl6gle" />
        <Offer data-id="element-9" data-mp="3mlatmwc87vop" />
        <Guarantee data-id="element-10" data-mp="3mkrcviybbdc9" />
        <Testimonials data-id="element-11" data-mp="3mk83wrqn3zad" />
        <Creator data-id="element-12" data-mp="3mjg8bgx1m1k3" />
        <FAQ data-id="element-13" data-mp="3rc9d24sih9w6" />
        <FinalCTA data-id="element-14" data-mp="3rbr9en3irte8" />
      </main>
      <Footer data-id="element-15" data-mp="3rdkie91luppe" />
      <FloatingCTA data-id="element-16" data-mp="3rd1bdndhtlq5" />
      <PurchasePopup data-id="element-17" data-mp="3relumgucxi8p" />
    </div>;
}